<template>
  <SloLoader :loading="loading" size="xl">
    <ReturnDetails :returnRequest="returnRequest" class="my-xl md:my-2xl" />
  </SloLoader>
</template>

<script>
import t from '../../main/i18n';
import {handleApiErrors} from '../../main/utils';
import {mapGetters} from 'vuex';
import {marketplaceApi} from '../apis/marketplace';
import SloLoader from '../../../lib/components/SloLoader.vue';
import ReturnDetails from '../components/ReturnDetails.vue';

export default {
  components: {
    SloLoader,
    ReturnDetails
  },
  data() {
    return {
      loading: false,
      returnRequest: null
    };
  },
  async created() {
    this.loading = true;

    if (this.authenticated) {
      await this.$router.replace({
        name: 'marketplace-account-return',
        params: {code: this.$route.query?.returncode}
      });
      return;
    }

    const code = this.$route.query?.returncode;
    const email = this.$route.query?.email;
    const billZip = this.$route.query?.billZip;

    if (!code || !email || !billZip) {
      this.$snotify.error(t('Insufficient return information provided'));
      await this.$router.push({name: 'marketplace'});
    }

    await marketplaceApi.getReturn({code, email, billZip})
      .then(res => {
        this.loading = false;
        this.returnRequest = res.data;
      })
      .catch(async e => {
        handleApiErrors(e, this, 'Error retrieving return details');
        await this.$router.push({name: 'marketplace-auth-login'});
      });
  },
  computed: mapGetters('auth', ['authenticated'])
};
</script>
